<h1 matDialogTitle>
  {{ 'Replacing disk {name}' | translate: { name: data.diskName } }}
</h1>
<form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
  <ix-combobox
    formControlName="replacement"
    [label]="'Member Disk' | translate"
    [required]="true"
    [provider]="disksProvider"
    [tooltip]="helptext.dialogFormFields.disk.tooltip | translate"
  ></ix-combobox>

  <ix-checkbox
    formControlName="force"
    [label]="'Force' | translate"
    [tooltip]="helptext.dialogFormFields.force.tooltip | translate"
  ></ix-checkbox>

  <ix-form-actions>
    <button mat-button type="button" ixTest="cancel" matDialogClose>
      {{ 'Cancel' | translate }}
    </button>

    <button
      *ixRequiresRoles="[Role.FullAdmin]"
      mat-button
      type="submit"
      color="primary"
      ixTest="replace"
      [disabled]="form.invalid"
    >
      {{ 'Replace Disk' | translate }}
    </button>
  </ix-form-actions>
</form>
